import React, {useEffect, useState} from "react";
import PageHeader from "../../components/organisms/PageHeader";
import List from "../../components/organisms/List";
import request from "../../config/Axios";

const MuseumSpecial = () => {
    const [row, setRow] = useState([]);
    const navList = [
        {
            name: "상설 전시",
            link: "/program/museum/permanent"
        },
        {
            name: "특별 전시",
            link: "/program/museum/special"
        },
        {
            name: "지난 전시",
            link: "/program/museum/past"
        },
    ];
    useEffect(() => {
        (async () => {
            try {
                const specialResponse = await request.get(`boards/museum/special/posts`);
                setRow(specialResponse.data.data.postList);
            } catch (err) {
                console.error('api 호출 중 에러 발생:', err);
            }
        })();
    }, []);
    return (
        <>
            <PageHeader
                bTitle="프로그램"
                detail="특별 전시"
                desc="강아지숲 특별 전시를 안내해 드립니다."
                list={navList}
                top={true}
            />

            <List
                row={row}
                columns={3}
                category={"특별 전시"}
                pagination={false}
            />
        </>
    );
};

export default MuseumSpecial;
